import { IResponse } from "models";

export enum ActionType {
  EDIT_ACCOUNT = "action/EDIT_ACCOUNT",
  EDIT_ACCOUNT_SUCCESS = "action/EDIT_ACCOUNT_SUCCESS",
  EDIT_ACCOUNT_ERROR = "action/EDIT_ACCOUNT_ERROR",
  RESET_EDIT_ACCOUNT = "action/RESET_EDIT_ACCOUNT",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface EditAccountResponse extends IResponse {}
